import SearchTags, { SearchTabsProps, TagType } from "./SearchTags";

export { SearchTags, SearchTabsProps, TagType };

export default SearchTags;
